import { filter, startWith, Subject, tap } from 'rxjs';

import { PixelsVideoEvent } from '../../constants/Video';
import { metricsLog } from './utils';

export const playerEventManager = (sub: Subject<[string, any]>) => {
  sub.pipe(
    filter(([type]) => [
      PixelsVideoEvent.BEFORE_COMPLETE, PixelsVideoEvent.VIDEO_CHANGE
    ].includes(type as PixelsVideoEvent)),
    tap(([, eventData]) => {
      metricsLog('playerEventManager send generic end signal');
      sub.next([PixelsVideoEvent.VIDEO_ENDED, eventData]);
    }),
    startWith([PixelsVideoEvent.INIT]),
  ).subscribe();
};